import React, {Component} from'react';
import './Parallax.css'; 
 export default class Parallax extends Component{
     render(props){
         return(
            <div className="paralax-main">
                <div className="parallax nimated wow fadeInDown">
                     
                </div>
                <div className="hs-home-info">
                    <div className="container prlx">
                        <h1 className="text-left txt-mensage wow">Bem-vindo á HS Design, a<br/>  melhor gráfica de Luanda.</h1>
                        <h3 style={{color:'#fff'}} className="text-left txt-mensage wow">{this.props.desc}</h3>
                        {/* <p className="text-left wow hs-txtDesc">Para mais informações ligue pelo terminal: 94857687,  ou<br/> envia-nos um e-mail para hsdesign@gmail.com. </p> */}
                    </div>
                    <br/>
                    <br/>
                    <br/>
                </div>
            </div>
         );
     }
 }